import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';

@Directive({
  selector: '[accessibleTooltip]'
})
export class AccessibleTooltipDirective implements OnInit {
  constructor(public hostElement: ElementRef, private button: TooltipDirective) {}
  mouseOnTooltip: boolean = false;
  mouseOnTrigger: boolean = false;

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key == 'Escape') {
      this.button.hide();
    }
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.button.show();
    this.mouseOnTrigger = true;
  }

  @HostListener('focus') onFocus() {
    this.button.show();
    this.mouseOnTrigger = true;
  }

  @HostListener('mouseleave') onMouseLeave() {
    setTimeout(() => {
      if (!this.mouseOnTooltip) {
        this.button.hide();
      }
    }, 300);
    this.mouseOnTrigger = false;
  }

  @HostListener('blur') onBlur() {
    this.button.hide();
    this.mouseOnTrigger = false;
  }

  ngOnInit(): void {
    this.button.onShown.subscribe((onShown: { id: string }) => {
      const id = onShown.id;
      document.querySelector<HTMLElement>(`#${id}`).style['pointer-events'] = 'auto';
      document.querySelector(`#${id}`).addEventListener('mouseenter', () => {
        this.mouseOnTooltip = true;
      });
      document.querySelector(`#${id}`).addEventListener('mouseleave', () => {
        this.mouseOnTooltip = false;
        setTimeout(() => {
          if (!this.mouseOnTrigger) {
            this.button.hide();
          }
        }, 300);
      });
    });
  }
}
